<template>
    <div>
        <topback title="Tutorial" path="back"></topback>
        <md-field class="mt-6">
            <newitem :name="item.name" :ctime="item.ctime" :id="item.id"  v-for="item in news_list" v-bind:key="item.id"></newitem>
        </md-field>
    </div>
</template>
  
<script>
import topback from '@/components/topback'
import newitem from '@/components/newitem'
import { getnewslist } from '@/request/api'

export default {
    name: "Tutorial",
    components: {
        topback,
        newitem
    },
    data() {
        return {
            news_list: []
        }
    },
    created() {
        getnewslist({
            type: "tutorial",
        }).then(res=>{
            if(res.code === 200) {
                this.news_list = res.data.result
            }
        })
    },
    methods: {}
}
</script>
  


// WEBPACK FOOTER //
// src/views/tutorial.vue